var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path2, _path3, _rect13, _rect14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDueDate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    fill: "currentColor",
    viewBox: "0 0 36 36",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "clr-i-outline clr-i-outline-path-1",
    d: "M32.25,6H29V8h3V30H4V8H7V6H3.75A1.78,1.78,0,0,0,2,7.81V30.19A1.78,1.78,0,0,0,3.75,32h28.5A1.78,1.78,0,0,0,34,30.19V7.81A1.78,1.78,0,0,0,32.25,6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "clr-i-outline clr-i-outline-path-2",
    x: 8,
    y: 14,
    width: 2,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "clr-i-outline clr-i-outline-path-3",
    x: 14,
    y: 14,
    width: 2,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "clr-i-outline clr-i-outline-path-4",
    x: 20,
    y: 14,
    width: 2,
    height: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "clr-i-outline clr-i-outline-path-5",
    x: 26,
    y: 14,
    width: 2,
    height: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "clr-i-outline clr-i-outline-path-6",
    x: 8,
    y: 19,
    width: 2,
    height: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "clr-i-outline clr-i-outline-path-7",
    x: 14,
    y: 19,
    width: 2,
    height: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "clr-i-outline clr-i-outline-path-8",
    x: 20,
    y: 19,
    width: 2,
    height: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "clr-i-outline clr-i-outline-path-9",
    x: 26,
    y: 19,
    width: 2,
    height: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "clr-i-outline clr-i-outline-path-10",
    x: 8,
    y: 24,
    width: 2,
    height: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "clr-i-outline clr-i-outline-path-11",
    x: 14,
    y: 24,
    width: 2,
    height: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "clr-i-outline clr-i-outline-path-12",
    x: 20,
    y: 24,
    width: 2,
    height: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "clr-i-outline clr-i-outline-path-13",
    x: 26,
    y: 24,
    width: 2,
    height: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "clr-i-outline clr-i-outline-path-14",
    d: "M10,10a1,1,0,0,0,1-1V3A1,1,0,0,0,9,3V9A1,1,0,0,0,10,10Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "clr-i-outline clr-i-outline-path-15",
    d: "M26,10a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V9A1,1,0,0,0,26,10Z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "clr-i-outline clr-i-outline-path-16",
    x: 13,
    y: 6,
    width: 10,
    height: 2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    fillOpacity: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDueDate);
export default __webpack_public_path__ + "static/media/due-date.47353ef6afab283038aab7c2a51314a7.svg";
export { ForwardRef as ReactComponent };